import { Component, } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentBanner } from './environment-banner/environment-banner';


@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  imports: [EnvironmentBanner, RouterOutlet]
})
export class App { }